import React, {useEffect, useState} from 'react';
import {Box, makeStyles, Tab, Tabs, useTheme} from "@material-ui/core";
import PropTypes from "prop-types";
import {IoIosClose} from "react-icons/io";
import {useSelector} from "react-redux";
import {TextLink, Loader} from "../../../components";
import axios from "axios";
import {adminToken} from "../../../helper";
import styles from "../../../components/Table/styles.module.scss";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";
import GoogleMapWithAutocomplete from "../../../components/GoogleMap/GoogleMapWithAutocomplete";

function getModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#6CD7BB"
    }
}))


const initialFilterState = {
    line1: "",
    line2: "",
    line3: "",
    landmark: "",
    pincode: "",
    latitude: "",
    longitude: ""

};

function UpdateServiceAddressPopup({tableRows, handleCloseSAdd, currentSubID, currentSubcartID, setRefresh}) {
    const data = tableRows.filter((item)=>{
        return item?.id == currentSubID
    })
    console.log(JSON.stringify(data));
    const {user} = useSelector(state => ({
            user: state.user
        }));
        
    const [filterState, setFilterState] = useState({line1:data[0].line1, line2:data[0].line2, line3:data[0].line3, landmark:data[0].landmark, pincode:data[0].pincode, latitude:data[0].latitude, longitude:data[0].longitude});

    useEffect(() => {
        console.log('currentSubID --> '+currentSubcartID);
    }, [])

    const [modalStyle] = useState(getModalStyle);
    const [spLoader, setSpLoader] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState({
        lat: data[0].latitude,
        lng: data[0].longitude,
    });
    
    const classes = useStyles()

    
    const loading = useSelector(state => state.loading);

    return (
        <div style={modalStyle} className={'modal-paper-small update_service_address'}>
            <div className={'modal-top-bar'}>
                <IoIosClose
                    size={20}
                    className={'modal-close'}
                    onClick={handleCloseSAdd}
                />
            </div>
            <div className={'modal-header'}>
                <h5>Update Service Address</h5>
            </div>
            <div className={'modal-body'}>
                <div class="row">
                    <div class="col-md-6">
                        <GoogleMapWithAutocomplete
                                    city={data[0].city}
                                    state={data[0].state}
                                    apiKey="AIzaSyD3jdE33Ya5STr8tGdL2dn24QGJ5CNyyDg"
                                    filterState={filterState}
                                    setFilterState={setFilterState}
                                    />
                    </div>
                    <div class="col-md-6">
                        <table width="100%">
                            {/* <tr>
                                <td>line1</td>
                                <td>:</td>
                                <td>
                                    <input type="text" onChange={e =>
                                        setFilterState({...filterState, [e.target.name]: e.target.value})
                                    } name="line1" value={filterState?.line1}/>
                                </td>
                            </tr> */}
                            <tr>
                                <td>
                                    <lable>line2: </lable>
                                    <textarea readOnly type="text" onChange={e =>
                                        setFilterState({...filterState, [e.target.name]: e.target.value})
                                    } name="line2" value={filterState?.line2}></textarea>                                
                                </td>
                            </tr>
                            {/* <tr>
                                <td>line3</td>
                                <td>:</td>
                                <td><input type="text" onChange={e =>
                                        setFilterState({...filterState, [e.target.name]: e.target.value})
                                    } name="line3" value={filterState?.line3}/></td>
                            </tr> */}
                            <tr>
                                <td>
                                    <lable>Landmark: </lable>
                                    <input type="text" onChange={e =>
                                        setFilterState({...filterState, [e.target.name]: e.target.value})
                                    } name="landmark" value={filterState?.landmark}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <lable>Pincode: </lable>
                                    <input type="text" onChange={e =>
                                        setFilterState({...filterState, [e.target.name]: e.target.value})
                                    } name="pincode" value={filterState?.pincode} readOnly/>
                                </td>
                            </tr>
                            {/* <tr>
                                <td>
                                    <lable>latitude: </lable>
                                    <input type="text" onChange={e =>
                                        setFilterState({...filterState, [e.target.name]: e.target.value})
                                    } name="latitude" value={filterState?.latitude}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <lable>longitude: </lable>
                                    <input type="text" onChange={e =>
                                        setFilterState({...filterState, [e.target.name]: e.target.value})
                                    } name="longitude" value={filterState?.longitude}/>
                                </td>
                            </tr> */}
                        </table>
                        <button className='btn btn-primary' onClick={(status) => {
                            setSpLoader(true);
                            adminToken().then(token =>
                                axios.post(`${AWS_SERVER_APIS}/updateserviceaddress`, {
                                    cart_id: currentSubcartID,
                                    line2: filterState.line2,
                                    landmark: filterState.landmark,
                                    pincode: filterState.pincode,
                                    latitude: filterState.latitude,
                                    longitude: filterState.longitude,
                                }, {headers: {Authorization: `Bearer ${token}`}})
                                    .then(res => {
                                        if(res.data.type == 'error'){
                                            alert('Error: '+res.data.message);
                                        }else{
                                            alert('Service Address Updated Successfull!');
                                            handleCloseSAdd();
                                            setRefresh(Math.random());
                                        }
                                        setSpLoader(false);
                                    })
                            );
                            }}>Update</button> {spLoader ? (
                                <div className={styles.loading__container}>
                                <Loader />
                                </div>
                            ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateServiceAddressPopup;
